import { Injectable, Injector } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastMessageOptions } from 'primeng/api';
@Injectable({
  providedIn: 'root',
})
export class MessageManagerService {
  private isMessageVisible: boolean = false;
  private messageService!: MessageService;

  constructor(private injector: Injector) {}

  /**
   * Lazily load the MessageService to break the circular dependency.
   */
  private getMessageService(): MessageService {
    if (!this.messageService) {
      this.messageService = this.injector.get(MessageService);
    }
    return this.messageService;
  }

  /**
   * Adds a message with visibility and timeout management.
   * @param {Message} message - Message to be displayed.
   */
  add(message: ToastMessageOptions): void {
    if (this.isMessageVisible) {
      return; // Skip if a message is already being displayed
    }
    this.isMessageVisible = true;

    const duration = message.life || 3000; // Default duration if not provided

    this.getMessageService().add(message);

    // Reset visibility after the message duration
    setTimeout(() => {
      this.isMessageVisible = false;
    }, duration);
  }
}